import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Trophy.svg'

export const IconTrophy = IconSVG as IconComponent
